import React, { useEffect } from 'react';
import RfqDetailPresenter from './RfqDetailPresenter';
import {
  CapaErrorCode,
  useFetchQuotationUserRfqDetailQuery
} from '@generated/graphql';
import { WatchQueryFetchPolicy } from '@apollo/client';
import LoadingPresenter from '@components/Loading';
import { useSnackbar } from '@components/Provider';
import { RfqDetailData } from '../type';

interface Props {
  isPreview?: boolean;
  previewData?: RfqDetailData;
  rfqId?: string;
  matches?: boolean;
  fetchPolicy?: WatchQueryFetchPolicy;
}

const RfqDetailContainer: React.FC<Props> = ({
  rfqId,
  matches,
  fetchPolicy,
  previewData,
  isPreview = false
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { data, loading, error } = useFetchQuotationUserRfqDetailQuery({
    variables: {
      rfqId: rfqId ?? ''
    },
    skip: !rfqId || isPreview,
    fetchPolicy
  });

  const isNetworkError = !isPreview && error;

  const isInternalError =
    !isPreview &&
    data &&
    data?.fetchQuotationUserRfqDetail.result !== CapaErrorCode.Success;

  const isLoading = !isPreview && loading;

  const rfqDetail = data?.fetchQuotationUserRfqDetail.data ?? undefined;

  useEffect(() => {
    if (isNetworkError) {
      enqueueSnackbar(
        '네트워크 문제로 서비스 접속에 실패했습니다. 네트워크 연결 후 다시 시도해주세요.',
        { variant: 'error' }
      );
    }

    if (isInternalError) {
      enqueueSnackbar(
        '일시적인 오류로 서비스 접속에 실패했습니다. 새로고침 후 다시 시도해주세요. 새로고침 후에도 실패한 경우 채널톡으로 문의해주세요.',
        { variant: 'error' }
      );
    }

    // eslint-disable-next-line
  }, [isNetworkError, isInternalError]);

  return (
    <>
      {isLoading && <LoadingPresenter open />}

      <RfqDetailPresenter
        isPreview={isPreview}
        matches={matches}
        data={isPreview ? previewData : rfqDetail}
      />
    </>
  );
};

export default RfqDetailContainer;
